// extracted by mini-css-extract-plugin
module.exports = {"iconSearch":"styles_iconSearch__2erbQ","link":"styles_link__wnasG","iconLink":"styles_iconLink__vOXw5"};